import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})

export class TruncatePipe implements PipeTransform {

  private numberOfChars = 220;

  public transform(stringInput: string): string {
    const match = stringInput?.substr(0, this.numberOfChars);
    if (match?.length === stringInput?.length) { return stringInput; }
    return match + '...';
  }
}
